import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import classes from './ValidateName.module.css';

const ValidateName = props => {
  const { t } = useTranslation(['ui']);
  const userInfo = useSelector(state => state.userInfo);

  const validateNameBtn = () => {
    props.confirmName();
  };

  return (
    <Dialog
      open={props.open}
      fullWidth
      maxWidth="sm"
      className={classes.dialogcontainer}
    >
      <div className={classes.textContainer}>
        <p className={classes.text}>{t('earning_diploma')}</p>
        <p className={classes.text}>¡Sigue así!</p>
        <p className={classes.textAlert}>{t('finish_course')}</p>
      </div>
      <div className={classes.userNameContainer}>
        <p className={classes.userName}>
          {userInfo.data.nombre} {userInfo.data.apellido}
        </p>
      </div>
      <p className={classes.descriptionText}>
        {t('want_your_name')}
      </p>
      <div className={classes.btnsContainer}>
        <Button
          className={classes.changeNameBtn}
          component="a"
          href={`${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myProfile`}
        >
          {t('make_adjustment')}
        </Button>
        <Button
          className={classes.acceptNameBtn}
          onClick={validateNameBtn}
        >
          {t('my_name_is_correct')}
        </Button>
      </div>
    </Dialog>
  );
};

ValidateName.propTypes = {
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  confirmName: PropTypes.func
};

export default ValidateName;
